import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface AuthState {
  isAuth: boolean;
}

const initialState: AuthState = {
  isAuth: false,
};

export const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload;
    },
  },
});

export const authReducer = AuthSlice.reducer;

export const { setIsAuth } = AuthSlice.actions;
